export enum Step {
    Presets,
    Calendar,
}
